export function qs(href = location.href) {
  const result = {};
  let param = null;
  const reg = /[?&](.*?)=([^&#]*)/g;

  param = reg.exec(href);
  while (param) {
    // 上面已经decode过，不需要重复decode，过度decode会导致其它问题
    // result[param[1]] = param[2];
    try {
      result[param[1]] = decodeURIComponent(param[2]);
    } catch (e) {
      try {
        result[param[1]] = unescape(param[2]);
      } catch (escapeErr) {
        result[param[1]] = param[2];
      }
    }
    param = reg.exec(href);
  }
  return result;
}

export default qs;
